import type { AppCompoundButtonProps } from "./AppCompoundButton.Props";

export const isAppCompoundButtonProps = (props: {
  type: string;
}): props is AppCompoundButtonProps => {
  return (props as AppCompoundButtonProps).type === "AppCompoundButtonProps";
};
